import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconTextStyleStrike = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 10"
    aria-label="IconTextStyleStrike"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M0 4.767h12v.993H9.089c.158.328.238.688.233 1.053.01.345-.065.688-.217.999-.153.31-.377.58-.655.786a3.72 3.72 0 0 1-2.31.665 4.3 4.3 0 0 1-1.75-.357 2.97 2.97 0 0 1-1.261-.982 2.4 2.4 0 0 1-.447-1.426v-.076h1.336v.075a1.44 1.44 0 0 0 .568 1.21c.454.32 1.002.479 1.556.45.488.032.974-.095 1.384-.361a1.15 1.15 0 0 0 .467-.97 1.11 1.11 0 0 0-.614-1.066H.01zm8.897-3.401A2.8 2.8 0 0 0 7.75.364a3.8 3.8 0 0 0-1.675-.36 3.46 3.46 0 0 0-2.243.702 2.22 2.22 0 0 0-.872 1.786c-.002.327.072.65.215.944h1.73c-.055-.035-.122-.07-.163-.106a1.06 1.06 0 0 1-.436-.86 1.18 1.18 0 0 1 .459-1 2.1 2.1 0 0 1 1.31-.365 2.05 2.05 0 0 1 1.404.443 1.55 1.55 0 0 1 .492 1.211v.076h1.334v-.076a2.56 2.56 0 0 0-.41-1.397" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconTextStyleStrike);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
